import { render, staticRenderFns } from "./WorkShopDetail.vue?vue&type=template&id=34559703"
import script from "./WorkShopDetail.vue?vue&type=script&lang=js"
export * from "./WorkShopDetail.vue?vue&type=script&lang=js"
import style0 from "./WorkShopDetail.vue?vue&type=style&index=0&id=34559703&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports